import { apiSlice } from '../../store/api/apiSlice';
import { encryptData } from '../../shared/services/cryptoService';

const isLocalOrStaging = ['LOCAL', 'STAGING'].includes(
  process.env.REACT_APP_API_environment || ''
);

export const resetPasswordApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPhoneForResetPass: builder.query<
      any,
      { userId: string; userType: string }
    >({
      query: ({ userId, userType }) => ({
        url: isLocalOrStaging
          ? `GetPhoneForResetPass?userId=${userId}&userType=${userType}`
          : `api/GetPhoneForResetPass?userId=${userId}&userType=${userType}`,
        method: 'GET',
        service: isLocalOrStaging ? 'djangoEmis' : 'php3',
      }),
    }),

    getOldPassword: builder.mutation<any, any>({
      query: (payload) => ({
        url: 'api/GetOldPassword',
        method: 'POST',
        body: payload,
        service: 'php3',
      }),
    }),

    otpSendingSmsParGet: builder.mutation<any, any>({
      query: (payload) => ({
        url: 'api/OtpSendingSmsParGet',
        method: 'POST',
        body: payload,
        service: 'php3',
      }),
    }),

    resetPassOtpSubmit: builder.mutation<any, any>({
      query: (payload) => {
        const encryptedPayload = encryptData(payload);

        return {
          url: 'api/ResetPassOtpSubmit',
          method: 'POST',
          body: { records: encryptedPayload },
          service: 'php1',
        };
      },
    }),
  }),
});

export const {
  useLazyGetPhoneForResetPassQuery,
  useGetOldPasswordMutation,
  useOtpSendingSmsParGetMutation,
  useResetPassOtpSubmitMutation,
} = resetPasswordApi;
